module.exports = __webpack_public_path__ + "img/card-receive.51933b7e.svg";